export default "__VITE_ASSET__D0$8oVpb__"